<template>
	<div ref="EmergencySign" class="dialog-container">
		<div class="dialog sign" style="transform: translate(0, -220px); max-width: 90%;">
			<form @submit.stop="doValidation()">
				<div class="home-title">
					<div class="title-left" style="font-size: 20px;">
						<img style="width: 14px; height: 16px;" src="@/assets/images/login/sign_icon.png" />
						<span>담당자 배정</span>
					</div>
				</div>
				<div class="center dialog-flex sign-box">
					담당자로 배정받으시겠습니까?
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px; margin-top: 25px;">
					<button type="button" class="btn-cancel fright" title="Cancel" @click="doCancel()">
						닫기
					</button>
					<button type="button" class="btn-save fright" title="Cancel" @click="doInsert()">
						확인
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "EmergencySign",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
	},
	data() {
		return {
			item: {},
			isTab: 1,
		};
	},
	props: {
		collectData: {
			type: Object,
			required: true
		}
	},
	components:{
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");

			axios
				.post(this.config.contextRoot + "/field/selectSortOrder.do", this.item)
				.then((response) => {
					console.log(response);

					this.item = response.data.item;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				})
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");

			this.$set(this.collectData, "userId", sessionStorage.getItem('userId'));
			axios
				.post(this.config.contextRoot + "/home/insertManager.do", this.collectData)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.doClose();
							location.reload();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.doClose();
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.EmergencySign.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.EmergencySign.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isSignPopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		}
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
.sign{
	width: 500px;
	height: 280px;
	background-color: #fff;
}
.sign-box{
	width: 100%;
	height: 120px;
	margin-top: 10px;
	border-top: 1px solid #191C26;
	background-color: #F8F9FB;
	font-weight: bold;
	display: flex;
    justify-content: center;
    align-items: center;
}
</style>